module.exports = __webpack_public_path__ + "img/bp-goods-and-services.f901680e.svg";